import React from 'react'
import styles from './row.styles'
import injectSheet from 'react-jss'

const Row = ({ classes, children }) => (
  <div className={classes.row}>
    <div className={classes.holder}>{children}</div>
  </div>
)

export default injectSheet(styles)(Row)
